  <template>
    <div class="register-bank">
      <div class="d-flex justify-space-between align-center mb-2 gap-4">
        <v-text-field
          v-model="search"
          label="Pesquisar"
          outlined
          hide-details
          dense
        ></v-text-field>
        <v-btn color="primary" small @click="openDialogToAdd">
          <v-icon left small> mdi-plus </v-icon>
          Banco
        </v-btn>
      </div>

      <v-progress-linear v-if="loading" indeterminate color="primary" />
      <v-alert v-if="error" type="error" dismissible @input="clearError">
        {{ error }}
      </v-alert>

      <p
        v-if="filteredBanks.length === 0"
        class="text-caption text--secondary mb-0 text-center"
      >
        Nenhum banco encontrado
      </p>
      <p v-else class="text-caption text--secondary mb-0 text-center">
        {{ filteredBanks.length }} banco{{ filteredBanks.length > 1 ? "s" : "" }}
        encontrado{{ filteredBanks.length > 1 ? "s" : "" }}
      </p>

      <v-row dense class="mx-0">
        <v-col
          v-for="bank in filteredBanks"
          :key="bank.id"
          cols="12"
          md="6"
          lg="4"
        >
          <BankCard
            :bank="bank"
            @edit-bank="openDialogToEdit"
            class="h-full"
          />
        </v-col>
      </v-row>

      <BankDialog
        v-model="dialogOpen"
        :bank="selectedBank"
        @bank-saved="handleBankSaved"
        @error="handleError"
      />
    </div>
  </template>

  <script>
  import BankDialog from "@/components/admin/banks/BankDialog.vue";
  import BankCard from "@/components/admin/banks/BankCard.vue";
  import banksService from "@/services/admin/banks";

  export default {
    name: "Banks",
    components: {
      BankDialog,
      BankCard,
    },
    data() {
      return {
        dialogOpen: false,
        selectedBank: null,
        error: null,
        loading: false,
        search: "",
        banks: [],
      };
    },
    computed: {
      filteredBanks() {
        return this.banks.filter((bank) => {
          const lowerSearch = this.search.toLowerCase();
          return (
            bank.name.toLowerCase().includes(lowerSearch) ||
            bank.code.toLowerCase().includes(lowerSearch)
          );
        });
      },
    },
    methods: {
      openDialogToAdd() {
        this.selectedBank = null;
        this.dialogOpen = true;
      },

      openDialogToEdit(bank) {
        this.selectedBank = bank;
        this.dialogOpen = true;
      },

      async fetchBanks() {
        this.loading = true;
        try {
          const response = await banksService.getAllBanks();
          this.banks = response.banks;
        } catch (error) {
          this.error = error.message || "Erro ao carregar bancos. Por favor, tente novamente.";
        } finally {
          this.loading = false;
        }
      },

      handleBankSaved(savedBank) {
        const index = this.banks.findIndex((b) => b.id === savedBank.id);
        if (index !== -1) {
          this.$set(this.banks, index, savedBank);
        } else {
          this.banks.push(savedBank);
        }
        this.error = null;
      },

      handleError(errorMessage) {
        this.error = errorMessage;
      },

      clearError() {
        this.error = null;
      },
    },
    mounted() {
      this.fetchBanks();
    },
  };
  </script>

  <style scoped></style>
